import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';
import { ROTTE, perche } from '../staff/Provvigione';
import { quandoBreve } from './comuni';
import '../staff/provvigioni.css';

// Impostazioni → Provvigioni (solo admin): quello che si scrive da solo quando si compila una provvigione nuova —
// il compenso standard chiesto al cliente (importo fisso o percentuale, con o senza IVA e con la sua aliquota), la
// percentuale che di solito riconosce l'agenzia e quella che va al collaboratore. Le provvigioni già scritte non
// si toccano. Dati: GET/PUT /api/impostazioni/provvigioni (backend/provvigioni.py).

const CAMPI = [
  ['compenso_standard', 'Compenso standard (€)', 'es. 3000'],
  ['compenso_percentuale', 'Compenso in percentuale (%)', 'es. 3'],
  ['aliquota_iva', 'Aliquota IVA (%)', 'es. 22'],
  ['percentuale_agenzia', '% standard dell\'agenzia', 'es. 3'],
  ['percentuale_collaboratore', '% standard del collaboratore', 'es. 20'],
];

const daServer = (v = {}) => Object.fromEntries([
  ['compenso_tipo', v.compenso_tipo || 'fisso'],
  ['compenso_iva', v.compenso_iva !== false],
  ...CAMPI.map(([k]) => [k, v[k] === null || v[k] === undefined ? '' : String(v[k])]),
]);

export const corpo = (v) => ({
  compenso_tipo: v.compenso_tipo,
  compenso_iva: v.compenso_iva,
  ...Object.fromEntries(CAMPI.map(([k]) => [k, v[k] === '' ? 0 : v[k]])),
});

const PROBLEMI = {
  403: 'Gli standard delle provvigioni li cambia solo l\'admin.',
  404: 'Le provvigioni non sono ancora collegate al server: gli standard si potranno scrivere appena lo sono.',
  errore: 'Non riesco a caricare gli standard delle provvigioni.',
};

const Provvigioni = () => {
  const [valori, setValori] = useState(null);
  const [salvato, setSalvato] = useState(null);
  const [problema, setProblema] = useState(null);
  const [inVolo, setInVolo] = useState(false);

  const leggi = (d) => {
    setValori(daServer(d.impostazioni));
    setSalvato(d.salvato_il ? { il: d.salvato_il, da: d.salvato_da } : null);
  };

  useEffect(() => {
    let vivo = true;
    axios.get(`${API}${ROTTE.impostazioni}`)
      .then((r) => {
        if (!vivo) return;
        // Una rotta che non c'è ancora, in locale, torna la pagina del sito: meglio dirlo che mostrare campi finti
        if (!r.data || typeof r.data !== 'object' || typeof r.data.impostazioni !== 'object') { setProblema(PROBLEMI[404]); return; }
        leggi(r.data);
      })
      .catch((e) => { if (vivo) setProblema(perche(e, PROBLEMI)); });
    return () => { vivo = false; };
  }, []);

  const salva = async () => {
    setInVolo(true);
    try {
      const r = await axios.put(`${API}${ROTTE.impostazioni}`, corpo(valori));
      if (r.data && typeof r.data.impostazioni === 'object') leggi(r.data);
      toast.success('Standard delle provvigioni salvati');
    } catch (e) {
      toast.error(perche(e, { ...PROBLEMI, 404: 'Non salvati: le provvigioni non sono ancora collegate al server.', errore: 'Non salvati' }));
    } finally { setInVolo(false); }
  };

  const cambia = (k) => (e) => setValori({ ...valori, [k]: e.target.value });

  if (problema) {
    return (
      <section className="card" data-testid="impostazioni-provvigioni">
        <div className="ttl"><div className="i"><Icona nome="euro" /></div><h2>Provvigioni</h2></div>
        <p className="vuoto" data-testid="provvigioni-problema">{problema}</p>
      </section>
    );
  }
  if (!valori) return <p className="vuoto">Carico gli standard delle provvigioni…</p>;

  return (
    <section className="card" data-testid="impostazioni-provvigioni">
      <div className="ttl"><div className="i"><Icona nome="euro" /></div><h2>Provvigioni</h2>
        {salvato && <small>salvati {quandoBreve(salvato.il, true)}{salvato.da ? ` · ${salvato.da}` : ''}</small>}</div>
      <p className="imp-nota">Quello che si scrive da solo quando si compila una provvigione nuova. Si cambia sempre pratica per pratica, e
        le provvigioni già scritte restano come sono. La quota del collaboratore si conta sull'incasso netto (spese tolte).</p>
      <div className="imp-campi" style={{ marginTop: '.8rem' }}>
        <label>Compenso dal cliente
          <select value={valori.compenso_tipo} onChange={cambia('compenso_tipo')} aria-label="Tipo di compenso standard">
            <option value="fisso">Importo fisso</option>
            <option value="percentuale">Percentuale sul prezzo</option>
          </select>
        </label>
        <label>IVA
          <select value={valori.compenso_iva ? 'si' : 'no'} onChange={(e) => setValori({ ...valori, compenso_iva: e.target.value === 'si' })} aria-label="IVA standard">
            <option value="si">Sì, con IVA</option>
            <option value="no">No, senza IVA</option>
          </select>
        </label>
        {CAMPI.map(([k, nome, esempio]) => (
          <label key={k}>{nome}<input value={valori[k]} onChange={cambia(k)} inputMode="decimal" placeholder={esempio} /></label>
        ))}
      </div>
      <div className="imp-azioni">
        <button type="button" className="btn sm p" onClick={salva} disabled={inVolo}>{inVolo ? 'Salvo…' : 'Salva'}</button>
      </div>
    </section>
  );
};

export default Provvigioni;
